import React from 'react'
import { Link } from 'react-router-dom'

export default function Status({ title, action }) {
  return (
    <div className='w-full flex justify-between items-center p-6 py-3 bg-main rounded-md shadow-sm'>
        <p className='text-white font-bold text-[18px]'>{title}</p>
        <Link to={action.link} className='text-main text-[14px] px-4 py-2 rounded-sm bg-white'>{action.title}</Link>
    </div>
  )
}
